import React, { Component } from "react";
import Page from "../2/Controls/Page";
import PageSection from "../2/Controls/PageSection";
import axios from "axios";
const BaseURL = "https://backend-197598313260.asia-south1.run.app";
//const BaseURL = "http://localhost:4000"
class PackagingTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      packagingData: [],
      showSaveConfirmation: false,
      receivingUser: "",
      saveInProgress: false,
      draftSaved: false,
      searchFocused: false,
      showValidationError: false,
      searchTerm: null,
      vendorStockInwardId: this.props.match.params.key,
      transferDetails: null, // To store the main transfer details,
      statusFilter: "all", // New state for status filter
      saved: false, // To show success message after saving
    };
  }

  componentDidMount() {
    this.fetchPackagingData();
  }

  fetchPackagingData = async () => {
    try {
      const { vendorStockInwardId, searchTerm } = this.state;
      const res = await axios.get(
        `${BaseURL}/v1/vendorstockinward/${vendorStockInwardId}/packaging`
      );

      if (res.data.code === "0") {
        if (res.data.data && res.data.data.Status === "Put away - Pending") {
          this.props.history.push({
            pathname: `/home/inventory/whinbound/${vendorStockInwardId}`,
          });
        }
        let packagelist = res.data.data.PackageList || [];
        for (let i = 0; i < packagelist.length; i++) {
          packagelist[i].index = i;
        }
        this.setState({
          //   packagingData: res.data.data.PackageList || [],
          packagingData: packagelist,
          transferDetails: res.data.data,
        });
      } else {
        console.error("Error fetching packaging data:", res.data.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  handleStatusUpdate = async (index, newStatus) => {
    try {
      const { packagingData, vendorStockInwardId } = this.state;

      // get only the updated item
      const updatedItem = { ...packagingData[index], Status: newStatus };

      // Update local state immediately for better UX
      const updatedPackageList = packagingData.map((item, i) =>
        i === index ? updatedItem : item
      );
      this.setState({ packagingData: updatedPackageList });

      // ✅ send only the updated item, not the full list
      //   /vendorstockinward/package/statusupdate/:id
      const res = await axios.put(
        `${BaseURL}/v1/vendorstockinward/package/statusupdate/${vendorStockInwardId}`,
        {
          packageList: updatedItem, // <-- sirf ek item array ke andar
          registrationID: this.props.user.user.RegistrationID,
          storeID: this.props.user.store.key,
        }
      );

      if (res.data.code !== "0") {
        // Revert if API call fails
        this.setState({ packagingData });
        alert("Failed to update status: " + res.data.message);
        await this.fetchPackagingData();
        return false;
      }
      this.setState({ saved: true });
      await this.fetchPackagingData();
      setTimeout(() => this.setState({ saved: false }), 3000);
    } catch (error) {
      console.log("Status update error:", error);
      alert("Error updating status. Please try again.");
      // Revert on error
      this.setState({ packagingData: this.state.packagingData });
    }
  };

  validateBeforeSave = () => {
    const hasPendingItems = this.state.packagingData.some(
      (item) => item.Status === "Pending"
    );

    if (hasPendingItems) {
      this.setState({ showValidationError: true });
      return false;
    }
    return true;
  };

  showConfirmationDialog = () => {
    if (!this.validateBeforeSave()) return;

    this.setState({ showSaveConfirmation: true });
  };

  handleSave = async (isDraft = false) => {
    if (!this.validateBeforeSave()) return;

    this.setState({ saveInProgress: true });

    try {
      const { vendorStockInwardId, packagingData } = this.state;

      const res = await axios.put(
        `${BaseURL}/v1/vendorstockinward/package/confirm/${vendorStockInwardId}`,
        {
          //   status: "Put away - Pending",
          userId: this.props.user.user.key,
          registrationID: this.props.user.user.RegistrationID,
          storeID: this.props.user.store.key,
          //   receivingTime: new Date().toISOString(),
        }
      );

      if (res.data.code === "0") {
        this.setState({
          showSaveConfirmation: false,
          saveInProgress: false,
          saved: true,
        });
        setTimeout(() => this.setState({ saved: false }), 3000);

        // alert("Packaging data saved successfully!");
        this.props.history.push({
          pathname: `/home/inventory/whinbound/${vendorStockInwardId}`,
        });
      } else {
        alert("Error saving data: " + res.data.message);
        await this.fetchPackagingData();
        this.setState({ saveInProgress: false });
      }
    } catch (error) {
      //   console.log("Save API Error:", error);
      //   console.error("Status update error:", error);
      //   let message = "Error updating status. Please try again.";

      //   if (error.response) {
      //     // Server responded with a status code outside 2xx
      //     message =
      //       error.response.data.message ||
      //       "Server Error:" + error.response.status;
      //   } else if (error.request) {
      //     // Request was made but no response received
      //     message = "No response from server. Please check your network.";
      //   } else {
      //     // Something else happened while setting up request
      //     message = error.message;
      //   }
      alert("Error saving");
      await this.fetchPackagingData();
      this.setState({ saveInProgress: false });
    }
  };

  renderStatusButtons = (currentStatus, index) => {
    return (
      <div className="d-flex" style={{ display: "flex", gap: "14px" }}>
        <button
          // className={`btn btn-sm ${currentStatus === "Received" ? "btn-success" : "btn-success"}`}
          className="btn btn-flat btn-default"
          onClick={() => this.handleStatusUpdate(index, "Received")}
        >
          Received
        </button>
        <button
          //className={`btn btn-sm ${currentStatus === "Not Received" ? "btn-success" : "btn-success"}`}
          className="btn btn-flat btn-default"
          onClick={() => this.handleStatusUpdate(index, "Not Received")}
        >
          Not Received
        </button>
      </div>
    );
  };

  getFilteredItems() {
    const { searchTerm, packagingData, statusFilter } = this.state;
    let filteredItems = packagingData;
    if (statusFilter !== "all") {
      filteredItems = filteredItems.filter((item) => {
        switch (statusFilter) {
          case "received":
            return item.Status === "Received";
          case "not_received":
            return item.Status === "Not Received";
          default:
            return true;
        }
      });
    }

    if (searchTerm) {
      filteredItems = filteredItems.filter(
        (item) =>
          item.PackageID.toLowerCase().includes(
            searchTerm.toLowerCase().trim()
          ) ||
          item.Status.toLowerCase().includes(searchTerm.toLowerCase().trim())
      );
    }

    return filteredItems;

    // if (!searchTerm) return packagingData;

    // return packagingData.filter(item =>
    //     item.PackageID.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //     item.Status.toLowerCase().includes(searchTerm.toLowerCase()))
  }
  
  // Calculate total quantity
  calculateTotalQty = () => {
    const filteredItems = this.getFilteredItems();
    return filteredItems.reduce(
      (total, item) => total + (parseInt(item.Qty) || 0),
      0
    );
  };

  renderTable() {
    const filteredItems = this.getFilteredItems();
    const totalQty = this.calculateTotalQty();

    return (
      <div className="">
        {this.state.showValidationError && (
          <div
            className="alert alert-danger"
            style={{
              marginBottom: "15px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <i
              className="fa fa-exclamation-triangle mr-2"
              style={{ fontSize: "18px" }}
            ></i>
            <div>
              <strong>Validation Error</strong>
              <div>
                Before saving, please ensure all packages have either "Received"
                or "Not received" status.
              </div>
              <small>Pending packages cannot be saved.</small>
            </div>
          </div>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div style={{ width: "300px", position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search by Tote No..."
                value={this.state.searchTerm}
                onChange={this.handleSearch}
                onFocus={() => this.setState({ searchFocused: true })}
                onBlur={() => this.setState({ searchFocused: false })}
                style={{
                  borderRadius: "20px",
                  padding: "10px 20px 10px 35px",
                  boxShadow: this.state.searchFocused
                    ? "0 0 0 0.2rem rgba(0,123,255,.25)"
                    : "none",
                  borderColor: this.state.searchFocused ? "#80bdff" : "#ced4da",
                  transition: "all 0.3s ease",
                }}
              />
              <i
                className="fa fa-search"
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#6c757d",
                }}
              ></i>
            </div>

            {/* Add Status Filter Dropdown */}
            <div
              className="form-group"
              style={{ marginBottom: 0, minWidth: "200px" }}
            >
              <select
                className="form-control"
                value={this.state.statusFilter}
                onChange={(e) =>
                  this.setState({ statusFilter: e.target.value })
                }
              >
                <option value="all">All Statuses</option>
                {/* <option value="pending">Put away - Pending</option>
                                <option value="done">Put away - Done</option> */}
                <option value="received">Received</option>
                <option value="not_received">Not received</option>
              </select>
            </div>
          </div>
        </div>

        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>SrNo</th>
              <th>Tote No</th>
              <th>QTY</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredItems.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.PackageID}</td>
                <td>{item.Qty}</td>
                {/* <td
                                    className={
                                        item.Status === "Pending"
                                            ? "text-dark"
                                            : item.Status === "Not Received"
                                                ? "text-danger"
                                                : item.Status === "Received"
                                                    ? "text-success"
                                                    : ""
                                    }
                                >
                                    {item.Status}
                                </td> */}
                <td>
                  <span
                    style={{
                      display: "inline-block",
                      padding: "4px 10px",
                      borderRadius: "12px",
                      color: "#fff",
                      fontSize: "12px",
                      fontWeight: "500",
                      backgroundColor:
                        item.Status === "Pending"
                          ? "#777" // grey
                          : item.Status === "Not Received"
                          ? "#dc3545" // red
                          : item.Status === "Received"
                          ? "#28a745" // green
                          : "#999", // default
                    }}
                  >
                    {item.Status}
                  </span>
                </td>

                <td>{this.renderStatusButtons(item.Status, item.index)}</td>
              </tr>
            ))}
          </tbody>
          {/* Footer row with total quantity */}
          <tfoot>
            <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}>
              <td colSpan="2" style={{ textAlign: "right" }}>
                Total
              </td>
              <td>{totalQty}</td>
              {/* <td colSpan="2"></td> */}
              <td></td>
              <td></td>
              {/* <td ></td> */}
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }

  renderConfirmationModal() {
    return (
      <div
        className="modal"
        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm Save</h5>
              <button
                type="button"
                className="close"
                onClick={() => this.setState({ showSaveConfirmation: false })}
              >
                &times;
              </button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to save these changes?</p>
              <p>This will mark the transfer as "Put away - Pending".</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => this.setState({ showSaveConfirmation: false })}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => this.handleSave(false)}
                disabled={this.state.saveInProgress}
              >
                {this.state.saveInProgress ? "Saving..." : "Confirm Save"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderFooter() {
    const { saved } = this.state;

    return (
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: "#f8f9fa",
          padding: "15px",
          borderTop: "1px solid #dee2e6",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "0 auto",
          }}
        >
          <div style={{ flex: 1 }}>
            {saved && (
              <div
                style={{
                  color: "#28a745",
                  backgroundColor: "#d4edda",
                  borderColor: "#c3e6cb",
                  padding: "10px",
                  borderRadius: "4px",
                  display: "inline-block",
                }}
              >
                <i className="fa fa-check-circle mr-2"></i>
                PackageID status update saved successfully!
              </div>
            )}
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <button
              type="button"
              className="btn btn-flat btn-default"
              onClick={() => {
                // this.props.history.push({
                //   pathname: "/home/inventory/whinbound",
                // });
                const { state } = this.props.location;
                if (state && state.verification) {
                  this.props.history.push({
                    pathname: "/home/pincode/whinboundverification",
                  });
                } else {
                  this.props.history.push({
                    pathname: "/home/inventory/whinbound",
                  });
                }
              }}
            >
              <i className="fa fa-arrow-left mr-2"></i> Back
            </button>

            {/* <button
                            type="button"
                            className="btn btn-flat"
                            onClick={() => this.handleSave(true)}
                            style={{
                                backgroundColor: '#17a2b8',
                                color: 'white',
                            }}
                        >
                            Save Draft
                        </button> */}

            <button
              type="button"
              className="btn btn-flat btn-success pull-right"
              onClick={this.showConfirmationDialog}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    );
  }

  handleSearch = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  // renderTransactionDetails() {
  //     const { transferDetails } = this.state;

  //     if (!transferDetails) return null;

  //     return (
  //         <div style={{
  //             backgroundColor: '#f8f9fa',
  //             padding: '15px',
  //             borderRadius: '5px',
  //             marginBottom: '20px',
  //             display: 'flex',
  //             justifyContent: 'space-between'
  //         }}>
  //             <div style={{ flex: 1, marginRight: '20px' }}>
  //                 {/* <h5 style={{ marginBottom: '15px' }}>Transfer Details:</h5> */}
  //                 {/* <div style={{ marginBottom: '5px' }}><strong>PO No:</strong> {transferDetails.PONo}</div> */}
  //                 <div style={{ marginBottom: '5px' }}><strong>SO No:</strong> {transferDetails.SONo}</div>
  //                 <div style={{ marginBottom: '5px' }}><strong>SI No:</strong> {transferDetails.SINo}</div>
  //                 <div style={{ marginBottom: '5px' }}><strong>Vendor:</strong> {transferDetails.VendorName} ({transferDetails.VendorCode})</div>

  //             </div>

  //             <div style={{ flex: 1, marginRight: '20px' }}>

  //                 <div>
  //                     <strong>Status:</strong>
  //                     <span style={{
  //                         backgroundColor: transferDetails.Status === "Put away - Pending" ? '#9fa728ff' : '#28a745',
  //                         color: 'white',
  //                         padding: '3px 8px',
  //                         borderRadius: '4px',
  //                         fontSize: '12px',
  //                         marginLeft: '8px'
  //                     }}>
  //                         {transferDetails.Status}
  //                     </span>
  //                 </div>
  //             </div>

  //         </div>
  //     );
  // }

  renderTransactionDetails() {
    const { transferDetails } = this.state;
    if (!transferDetails) return null;

    return (
      <div
        style={{
          backgroundColor: "#f8f9fa",
          padding: "15px",
          borderRadius: "5px",
          marginBottom: "20px",
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        <div style={{ minWidth: "200px", flex: 1 }}>
          {/* <h6 style={{ marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>Invoice Details</h6> */}
          <div style={{ marginBottom: "5px" }}>
            <strong>Invoice No:</strong> {transferDetails.SINo || "N/A"}
          </div>
          <div style={{ marginBottom: "5px" }}>
            <strong>Invoice Date:</strong>{" "}
            {transferDetails.CreatedDate
              ? new Date(transferDetails.CreatedDate).toLocaleDateString()
              : "N/A"}
          </div>
          <div style={{ marginBottom: "5px" }}>
            <strong>Invoice Amount:</strong> {transferDetails.SIAmount || "0"}
          </div>
          <div style={{ marginBottom: "5px" }}>
            <strong>Invoice Qty:</strong> {transferDetails.SIQty || "0"}
          </div>
        </div>

        {/* Column 2 - Sales Order Details */}
        {/* <div style={{ minWidth: '200px', flex: 1 }}>
                    
                    <div style={{ marginBottom: '5px' }}><strong>SO No:</strong> {transferDetails.SONo || 'N/A'}</div>
                    <div style={{ marginBottom: '5px' }}><strong>SO Amount:</strong> {transferDetails.SOAmount || '0'}</div>
                    <div style={{ marginBottom: '5px' }}><strong>SO Qty:</strong> {transferDetails.SOQty || '0'}</div>
                </div> */}

        <div style={{ minWidth: "200px", flex: 1 }}>
          {/* <h6 style={{ marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>Vendor Details</h6> */}
          <div style={{ marginBottom: "5px" }}>
            <strong>From:</strong>{" "}
            {transferDetails.VendorName ? transferDetails.VendorName : "N/A"}
          </div>
          <div style={{ marginBottom: "5px" }}>
            <strong>Address:</strong>{" "}
            {transferDetails.Address ? transferDetails.Address : "N/A"}
          </div>
        </div>

        <div style={{ minWidth: "200px", flex: 1 }}>
          {/* <h6 style={{ marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>Status & Timing</h6> */}
          <div
            style={{
              marginBottom: "5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {/* <strong style={{ marginRight: '5px' }}>Status:</strong> */}
            <span
              style={{
                backgroundColor:
                  transferDetails.Status === "Put away - Pending"
                    ? "#9fa728ff"
                    : "#28a745",
                color: "white",
                // padding: '3px 8px',
                // borderRadius: '4px',
                // fontSize: '12px'
                display: "inline-block",
                padding: "4px 10px",
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {transferDetails.Status || "N/A"}
            </span>
          </div>

          <div style={{ marginBottom: "5px" }}>
            <strong>Receiving Time:</strong>{" "}
            {transferDetails.ReceivingTime
              ? new Date(transferDetails.ReceivingTime).toLocaleString()
              : "N/A"}
          </div>
          <div style={{ marginBottom: "5px" }}>
            <strong>Completed Time:</strong>{" "}
            {transferDetails.CompletedTime
              ? new Date(transferDetails.CompletedTime).toLocaleString()
              : "N/A"}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Page
        hideHeader={true}
        title=""
        onClick={(action) => {
          // Handle page actions if needed
        }}
      >
        <PageSection>
          <div className="row">
            <div className="col-md-12">{this.renderTransactionDetails()}</div>
          </div>
          <div className="row">
            <div className="col-md-12">{this.renderTable()}</div>
          </div>
        </PageSection>

        {this.state.showSaveConfirmation && this.renderConfirmationModal()}
        {this.renderFooter()}
      </Page>
    );
  }
}

export default PackagingTable;
